import Accordion from './Accordion';
import styled from 'styled-components';

/**
 * Lista de acordeones de un nivel del árbol de soluciones.
 *
 * Ya no guarda cuál está abierto: eso lo dice la URL (openIds viene de la cadena
 * de ancestros de la solución que está en la URL). `parent` es la solución de la
 * que cuelga este nivel, y sirve para saber a dónde volver al cerrar.
 */
export default function AccordionsGroup({ solutions, parent = null, openIds }) {
  const list = Array.isArray(solutions) ? solutions : [];

  return (
    <StyledAccordionsGroup>
      <div className='col-12 containerAccordions'>
        <div className="accordion contenAccordion">
          {list.map((solution) => (
            <Accordion
              key={solution.id}
              solution={solution}
              parent={parent}
              openIds={openIds}
            />
          ))}
        </div>
      </div>
    </StyledAccordionsGroup>
  );
}

const StyledAccordionsGroup = styled.div`
  .containerAccordions{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;
    width: 100%;
  }
  .contenAccordion{
    width: inherit;
    @media(min-width: 768px){
      width: 100%;
    }
  }
`
